import { render, staticRenderFns } from "./BrowserNotification.vue?vue&type=template&id=f2fb1998&scoped=true&"
import script from "./BrowserNotification.vue?vue&type=script&lang=js&"
export * from "./BrowserNotification.vue?vue&type=script&lang=js&"
import style0 from "./BrowserNotification.vue?vue&type=style&index=0&id=f2fb1998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fb1998",
  null
  
)

export default component.exports